// External imports
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { StrictMode } from "react";
import React from "react";

// Local imports
import App from "./main";
import initI18n from "./utils/lang";
// import reportWebVitals from "./utils/googleAnalytic/web-vitals";
import "./styles/main.scss";
import AuthProvider from "./auth/authProvider";

// Global initialization
initI18n();

const htmlRoot = document.getElementById("root") as HTMLElement;
const reactRoot = ReactDOM.createRoot(htmlRoot);

reactRoot.render(
  process.env.REACT_APP_SCRICT_MODE === "true" ? (
    <AuthProvider>
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>
    </AuthProvider>
  ) : (
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  )
);
